export async function resolveCjLink(variantId: number, shopId: number, purchaseMethodId: number): Promise<string | null> {
    try {
        const res = await fetch(`/cj/attribution?variant_id=${variantId}&shop_id=${shopId}&purchase_method_id=${purchaseMethodId}`, {
            credentials: 'same-origin',
        });
        if (!res.ok) { return null; }
        const data = await res.json() as { url: string | null };
        return data.url ?? null;
    } catch {
        return null;
    }
}
